import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from './reducers';

export const NOTIFICATION_SHOW = 'NOTIFICATION_SHOW';
export const NOTIFICATION_HIDE = 'NOTIFICATION_HIDE';

interface ShowNotificationPayload {
  message: string;
  severity?: 'info' | 'success' | 'warning' | 'error';
  top?: number | undefined;
}

export const showNotification = ({ message, severity = 'info', top = undefined }: ShowNotificationPayload): ThunkAction<void, RootState, unknown, AnyAction> => 
  (dispatch) => {
    dispatch({ type: NOTIFICATION_SHOW, payload: { message, severity, top } });
  };

export const hideNotification = (): ThunkAction<void, RootState, unknown, AnyAction> => 
  (dispatch) => {
    dispatch({ type: NOTIFICATION_HIDE });
  };